
import { defineComponent, ref, computed, watch } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Messages from "@/core/helpers/Messages";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLButtonElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      email: Yup.string().required().label("Email"),
      password: Yup.string().min(4).required().label("Password"),
    });

    //Form submit function
    const onSubmitLogin = async (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Send login request
      await store.dispatch(Actions.LOGIN, values);
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];

      // if (!error) {
      //   Swal.fire({
      //     text: "You have successfully logged in!",
      //     icon: "success",
      //     buttonsStyling: false,
      //     confirmButtonText: "Continue",
      //     customClass: {
      //       confirmButton: "btn fw-bold btn-light-primary",
      //     },
      //   }).then(function () {
      //     // Go to page after successfully login
      //     router.push({ name: "dashboard" });
      //   });
      // } else {
      //   Swal.fire({
      //     text: error.length > 1 ? error[0] : error,
      //     icon: "error",
      //     buttonsStyling: false,
      //     confirmButtonText: "Try again!",
      //     customClass: {
      //       confirmButton: "btn fw-bold btn-light-danger",
      //     },
      //   });
      // }
      const errors = computed(() => {
        return store.getters.getErrors;
      });
      watch(errors, (newErrors) => {
        if (Object.keys(newErrors).length > 0) {
          Messages.showError(newErrors);
        }
      });
      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      onSubmitLogin,
      login,
      submitButton,
    };
  },
});
